// Registration Errors
export const NAME_REQUIRED = "Name is required to register!";
export const NAME_LONG_ERROR = "Name can not be more than 50 characters";

// Pulic key Errors
export const PUBLIC_KEY_REQUIRED = "Please add a public key!";

//Description Errors
export const DESCRIPTION_REQUIRED = "Please add a description!";
export const DESCRIPTION_LONG_ERROR =
  "Description can not be more than 500 characters";

//Registration Number error
export const REGISTRATION_NUMBER_REQUIRED = "Please add registration number!";

// Website Error
export const WEBSITE_ERROR = "Please add a link to the website!";

// Phone number error
export const PHONE_ERROR = "Phone number is required!";

// Comment Error
export const COMMENT_ERROR = "Please add a comment";

// Hospital error
export const HOSPITAL_REQUIRED = "Hospital is required!";

// common errors for login and registration form

//Password Errors
export const PASSWORD_REQUIRED = "Password is required!";
export const CONFIRM_PASSWORD_REQUIRED = "Please confirm password to register!";

// update password
export const CURRENT_PASSWORD_REQUIRED = "Current password is required!";
export const NEW_PASSWORD_REQUIRED = "New password is required!";
export const PASSWORD_SHORT_ERROR = "Password should be 6 characters minimum.";
export const PASSWORDS_MATCH_ERROR = `Passwords don't match`;

//Email Errors
export const EMAIL_INVALID_ERROR = "Invalid email address!";
export const EMAIL_NOT_LONG_ERROR = "Email not long enough!";
export const EMAIL_REQUIRED = "Email is required!";

// Role error
export const ROLE_REQUIRED = "User Role is required!";

// Adress error
export const ADDRESS_ERROR = "Address is required!";
export const ADDRESS_LONG_ERROR = "Address is too long! ";
export const ADDRESS_SHORT_ERROR = "Address is too short!";

export const TITLE_REQUIRED = "Title of the post is required";
export const TAG_REQUIRED = "Atleast 1 Tag is required for the post";
export const IMAGE_REQUIRED = "Atleast 1 Image is required for the post";
